import domReady from "@wordpress/dom-ready";

domReady(() => {
    const filterList = document.querySelector(".projects-filters");

    // Only initialize filtering if the filter list exists
    if (!filterList) {
        return;
    }

    const filterButtons = filterList.querySelectorAll(".filter-button");
    const projects = document.querySelectorAll(".project");

    let projectIndex = 0;
    projects.forEach((project) => {
        project.style.viewTransitionName = `proj-${++projectIndex}`;
    });

    filterButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
            let projectCategory = e.target.getAttribute("data-filter");
            if (!document.startViewTransition) {
                updateActiveButton(e.target);
                filterEvents(projectCategory);
            }
            document.startViewTransition(() => {
                updateActiveButton(e.target);
                filterEvents(projectCategory);
            });
        });
    });


    function updateActiveButton(newButton) {
        filterList.querySelector(".active").classList.remove("active");
        newButton.classList.add("active");
    }

    function filterEvents(filter) {
        projects.forEach((project) => {
            let eventCategory = project.getAttribute("data-category");
            console.log('eventCategory', eventCategory.split(" "));
            if (filter === "all" || eventCategory.includes(filter)) {
                project.removeAttribute("hidden");
            } else {
                project.setAttribute("hidden", "");
            }
        });
    }
})


